"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTableCreateButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _DmsButton = require("../DmsButton/DmsButton");
var _DmsSelect = require("../DmsSelect/DmsSelect");
var _DmsSwitch = require("../DmsSwitch/DmsSwitch");
var _DmsFilePicker = require("../DmsFilePicker/DmsFilePicker");
var _DmsTableButton = require("./DmsTableButton");
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _DmsPasswordValidation = require("../DmsPasswordValidation/DmsPasswordValidation");
var _DateTimePicker = require("@mui/x-date-pickers/DateTimePicker");
var _LocalizationProvider = require("@mui/x-date-pickers/LocalizationProvider");
var _AdapterDayjs = require("@mui/x-date-pickers/AdapterDayjs");
var _TimeZone = require("../../constants/TimeZone");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _utc = _interopRequireDefault(require("dayjs/plugin/utc"));
const _excluded = ["filter", "sortable"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
_dayjs.default.extend(_utc.default);

/**
 * DmsTableCreateButton component provides a button to create a new item in the DmsTable.
 * 
 * Supports predefined values for fields:
 * - If `predefined_value` is set in the header for any column, its value will be automatically
 *   prefilled in the create form and rendered as read-only (disabled input) for the user.
 * 
 * Example of header definition:
 * {
 *   label: "Requisition Type",
 *   column_name: "requisition_type_pk",
 *   predefined_value: 123,  // Value automatically set and shown as read-only
 *   hidden: true
 * }
 *
 * @param {Object} props - Component properties.
 * @param {JSX.Element} [props.button_icon=<AddIcon />] - Icon for the create button.
 * @param {string} [props.button_label] - Label for the create button.
 * @param {string} [props.button_text] - Text for the create button.
 * @param {function} [props.handler=null] - Function to handle the create action.
 * @param {Array} props.header - Header information for the table.
 * @param {boolean} [props.needs_authentication=null] - Whether authentication is needed.
 * @param {Object} props.table - Reference to the table affected by the button.
 * @param {string} [props.title=intl.get("Create").d("Create")] - Title of the create modal.
 * @param {string} props.url - URL for the create request.
 * @param {string} [props.variant] - Variant of the create button.
 * @param {string} [props.queryData] - Additional query data for the URL.
 * @param {boolean} [props.disabled=false] - Whether the create button is disabled.
 * @returns {JSX.Element} The DmsTableCreateButton component.
 */
const DmsTableCreateButton = _ref => {
  let {
    button_icon = /*#__PURE__*/_react.default.createElement(_Add.default, null),
    button_label,
    button_text,
    handler = null,
    header,
    needs_authentication = null,
    table,
    title = _reactIntlUniversal.default.get("Create").d("Create"),
    url,
    variant,
    queryData,
    disabled = false
  } = _ref;
  const [modalState, setModalState] = (0, _react.useState)(false);
  const [modalData, setModalData] = (0, _react.useState)({});
  const [errorModalState, setErrorModalState] = (0, _react.useState)(false);
  const [errorModalTextData, setErrorModalTextData] = (0, _react.useState)("");
  const [password, setPassword] = (0, _react.useState)("");
  const [confirmPassword, setConfirmPassword] = (0, _react.useState)("");
  const handleButton = async (e, data) => {
    const initialData = {};
    header.forEach(item => {
      const key = item.form_column_name || item.column_name;
      if (item.predefined_value !== undefined) {
        initialData[key] = item.predefined_value;
      }
    });
    setModalData(initialData);
    setModalState(!modalState);
  };
  const handleSubmit = async e => {
    e.preventDefault();
    let data = _objectSpread({}, modalData);
    let validationErrors = [];
    header.forEach(item => {
      if (!item.column_name) return;
      let key = item.form_column_name || item.column_name;
      if (!(key in data)) {
        return;
      }
      const value = data[key];
      switch (item.fieldType) {
        case "int":
        case "integer":
          data[key] = parseInt(value, 10);
          break;
        case "float":
          data[key] = parseFloat(value);
          break;
        case "boolean":
          if (value !== 1 && value !== 0) {
            validationErrors.push("".concat(item.label || item.column_name, " must be 1 or 0."));
          } else {
            data[key] = value === 1;
          }
          break;
        default:
          data[key] = value;
      }
    });

    // If there are validation errors, display them and prevent submission
    if (validationErrors.length > 0) {
      setErrorModalTextData(validationErrors.join(" "));
      setErrorModalState(true);
      return;
    }
    if (handler) {
      handler(data);
    } else if (url) {
      try {
        if (!needs_authentication && table && table.current) {
          needs_authentication = table.current.needs_authentication;
        }
        const res = await (0, _DmsFetch.fetchData)(url, "POST", needs_authentication || null, data, true, true);
      } catch (error) {
        console.error("Fetch error:", error);
        setErrorModalTextData("An unexpected error occurred");
        setErrorModalState(true);
      }
    }
    if (table && table.current) {
      table.current.updateTable();
    }

    // Reset modal data on close
    setModalData({});
    setModalState(false);
  };
  const handleErrorButton = async (e, data, originalData) => {
    setErrorModalState(false);
  };
  const renderControl = item => {
    var _modalData$item$colum, _item$can_create;
    let key = item.column_name;
    const label = item.label ? item.label : item.column_name;
    const value = (_modalData$item$colum = modalData[item.column_name]) !== null && _modalData$item$colum !== void 0 ? _modalData$item$colum : "";
    const placeholder = item.placeholder || "";
    const control_type = item.control || "text";
    const fieldType = item.fieldType;
    let can_create = (_item$can_create = item.can_create) !== null && _item$can_create !== void 0 ? _item$can_create : true;
    const {
        filter,
        sortable
      } = item,
      selectProps = _objectWithoutProperties(item, _excluded);
    if (can_create === false || item.permissions && !(0, _DmsPermissions.havePermissions)(item.permissions)) {
      return null;
    }
    if (item.form_column_name) key = item.form_column_name;
    const getValue = event => {
      let data = event;
      if (event.label && event.item) data = event.item;
      if (item.properties && item.properties.form_value) {
        data = data[item.properties.form_value];
      }
      return data;
    };
    let input = null;
    if (item.predefined_value !== undefined) {
      const enumLabel = Object.keys(item.map).find(key => item.map[key] === item.predefined_value) || item.predefined_value;
      input = /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        value: enumLabel,
        className: "form-control",
        id: key,
        placeholder: placeholder,
        disabled: true
      });
    } else if (control_type === "switch") {
      const val = value === 1;
      input = /*#__PURE__*/_react.default.createElement(_DmsSwitch.DmsSwitch, {
        name: "render_switch",
        id: key,
        checked: val || false,
        onChange: (event, checked) => {
          setModalData(_objectSpread(_objectSpread({}, modalData), {}, {
            [key]: checked ? 1 : 0
          }));
        }
      });
    } else if (control_type === "select") {
      var _modalData$item$colum2, _item$properties$mult, _item$properties;
      const value = (_modalData$item$colum2 = modalData[item.column_name]) !== null && _modalData$item$colum2 !== void 0 ? _modalData$item$colum2 : "";
      input = /*#__PURE__*/_react.default.createElement(_DmsSelect.DmsSelect, _extends({}, selectProps, {
        value: value,
        multiple: (_item$properties$mult = (_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties.multiple) !== null && _item$properties$mult !== void 0 ? _item$properties$mult : false,
        id: key,
        onChange: event => {
          setModalData(_objectSpread(_objectSpread({}, modalData), {}, {
            [key]: getValue(event)
          }));
        }
      }));
    } else if (control_type === "folder" || control_type === "file") {
      input = /*#__PURE__*/_react.default.createElement(_DmsFilePicker.DmsFilePicker, {
        id: label,
        value: value,
        onChange: path => {
          setModalData(_objectSpread(_objectSpread({}, modalData), {}, {
            [key]: path
          }));
        },
        isDirectory: control_type === "folder"
      });
    } else if (control_type === "datetime") {
      input = /*#__PURE__*/_react.default.createElement(_LocalizationProvider.LocalizationProvider, {
        dateAdapter: _AdapterDayjs.AdapterDayjs
      }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_DateTimePicker.DateTimePicker, {
        format: "DD/MM/YYYY HH:mm",
        ampm: false,
        value: modalData[key] ? _dayjs.default.utc(modalData[key]) : null,
        onChange: newData => {
          setModalData(_objectSpread(_objectSpread({}, modalData), {}, {
            [key]: newData
          }));
        },
        timezone: _TimeZone.TIME_ZONE.UTC,
        renderInput: params => /*#__PURE__*/_react.default.createElement(TextField, _extends({}, params, {
          fullWidth: true
        }))
      }));
    } else {
      input = /*#__PURE__*/_react.default.createElement("input", {
        type: control_type,
        value: value,
        className: "form-control",
        onChange: event => {
          setModalData(_objectSpread(_objectSpread({}, modalData), {}, {
            [key]: event.target.value
          }));
          if (item.column_name === "user_password") {
            setPassword(event.target.value);
          } else if (item.column_name === "user_password_confirm") {
            setConfirmPassword(event.target.value);
          }
        },
        id: key,
        placeholder: placeholder
      });
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group",
      key: "".concat(key, "_group")
    }, /*#__PURE__*/_react.default.createElement("label", null, label), input, item.column_name === "user_password" && /*#__PURE__*/_react.default.createElement(_DmsPasswordValidation.DmsPasswordValidation, {
      password: password,
      confirmPassword: confirmPassword
    }));
  };
  if (!header && table && table.current && table.current.getHeader) {
    header = table.current.getHeader();
  }
  const modalrender = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: modalState,
    onClose: handleButton,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, null, title), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      mt: 1
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group"
  }, header.map(item => {
    if (!item.column_name) {
      return null;
    }
    return renderControl(item);
  }))))), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "secondary",
    text: _reactIntlUniversal.default.get("Cancel").d("Cancel"),
    onClick: handleButton
  }), /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "primary",
    onClick: handleSubmit,
    text: _reactIntlUniversal.default.get("Create").d("Create")
  }))), /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: errorModalState,
    onClose: handleErrorButton,
    maxWidth: "xs",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, null, _reactIntlUniversal.default.get("Error").d("Error")), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      mt: 1
    }
  }, errorModalTextData)), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "secondary",
    text: _reactIntlUniversal.default.get("Ok").d("Ok"),
    onClick: handleErrorButton
  }))));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DmsTableButton.DmsTableButton, {
    table: table,
    variant: variant,
    text: button_text,
    label: button_label,
    icon: button_icon,
    disabled: disabled,
    onClick: handleButton
  }), modalrender));
};
exports.DmsTableCreateButton = DmsTableCreateButton;